const state = () => ({
  userAgent: navigator?.userAgent?.toLowerCase(),
});

const getters = {
  userAgentLowerCased: (currentState) => currentState.userAgent?.toLowerCase(),
  isTablet: (currentState, currentGetters) => /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(currentGetters.userAgentLowerCased),
};

export default {
  namespaced: true,

  state,
  getters,
};
